/*
 * nf-feature-gallery — carrusel de tarjetas estilo Apple (FeatureCard).
 * Auto-inicializa todo .nf-fg del documento.
 * - Deslizable con el dedo (touch) + flechas en desktop.
 * - Las flechas avanzan ~una tarjeta; se deshabilitan en los extremos.
 * - Entrada con fade-up escalonado al entrar en viewport.
 */
(function () {
  if (window.__nfFgInit) return;
  window.__nfFgInit = true;

  function initGallery(root) {
    if (root.dataset.fgReady) return;
    root.dataset.fgReady = '1';

    var track = root.querySelector('.nf-fg__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.nf-fg__card'));
    var prev = root.querySelector('.nf-fg__paddle--prev');
    var next = root.querySelector('.nf-fg__paddle--next');

    function step() {
      var c = cards[0];
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 16;
      return c ? c.offsetWidth + gap : track.clientWidth * 0.8;
    }

    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Sin animación de entrada (estilo Apple): las tarjetas se ven de frente.
    // Se mantiene la clase is-in por compatibilidad, sin transition-delay para
    // que el hover responda de inmediato.
    cards.forEach(function (c) { c.classList.add('is-in'); });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.nf-fg').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
